import { render, staticRenderFns } from "./studentInfo - 副本.vue?vue&type=template&id=3970fe0a&scoped=true"
import script from "./studentInfo - 副本.vue?vue&type=script&lang=js"
export * from "./studentInfo - 副本.vue?vue&type=script&lang=js"
import style0 from "./studentInfo - 副本.vue?vue&type=style&index=0&id=3970fe0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970fe0a",
  null
  
)

export default component.exports